import React from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';

const AGENDA_STATUS_LABELS = {
    notStarted: 'Sin agenda',
    draft: 'Borrador',
    submitted: 'Enviada',
    notSubmitted: 'No enviada'
};

const SalesAgentsView = ({ agents, loading, canManageSellers = false, deletingSellerId = '', currentUserId = '', onAddSeller, onDeleteSeller, onViewAgenda }) => {
    if (loading) {
        return (
            <div className="surface-card border-round p-4 shadow-1 text-center text-color-secondary">
                Cargando vendedores...
            </div>
        );
    }

    if (!agents.length) {
        return (
            <div className="surface-card border-round p-4 shadow-1">
                <div className="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between gap-3">
                    <div>
                        <h3 className="mt-0">No hay vendedores activos</h3>
                        <p className="text-color-secondary mb-0">
                            Asigna el perfil Vendedor desde la administración de Usuarios para que aparezcan en esta lista.
                        </p>
                    </div>
                    {canManageSellers ? (
                        <Button
                            type="button"
                            label="Agregar vendedor"
                            icon="pi pi-user-plus"
                            className="w-full sm:w-auto"
                            onClick={onAddSeller}
                        />
                    ) : null}
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-column gap-3">
            <div className="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between gap-3">
                <div>
                    <h3 className="m-0">Vendedores</h3>
                    <p className="text-color-secondary mt-1 mb-0">Usuarios activos con perfil Vendedor.</p>
                </div>
                {canManageSellers ? (
                    <Button
                        type="button"
                        label="Agregar vendedor"
                        icon="pi pi-user-plus"
                        className="w-full sm:w-auto"
                        onClick={onAddSeller}
                    />
                ) : null}
            </div>

            <div className="ventas-agents-list">
                {agents.map((agent) => (
                    <div key={agent._id} className="surface-card border-round p-3 shadow-1 ventas-agent-card">
                        <div className="flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-3">
                            <div>
                                <h4 className="m-0">{agent.name || agent.email}</h4>
                                <p className="text-color-secondary mt-1 mb-0">{agent.email || '-'}</p>
                                <p className="text-color-secondary mt-1 mb-0">
                                    Agenda actual: {AGENDA_STATUS_LABELS[agent.agendaSummary?.status] || 'Sin agenda'}
                                </p>
                            </div>
                            <div className="flex flex-column sm:flex-row sm:align-items-center gap-2">
                                <Tag value={agent.active ? 'Activo' : 'Inactivo'} severity={agent.active ? 'success' : 'warning'} />
                                <Tag value="Vendedor" severity="info" />
                                <Tag value={`${Number(agent.agendaSummary?.plannedVisits || 0)} planificadas`} severity="secondary" />
                                <Tag value={`${Number(agent.agendaSummary?.completedVisits || 0)} realizadas`} severity="success" />
                                <Button
                                    type="button"
                                    label="Ver agenda"
                                    icon="pi pi-calendar"
                                    className="p-button-sm"
                                    onClick={() => onViewAgenda(agent)}
                                />
                                {canManageSellers && String(agent._id) !== String(currentUserId) ? (
                                    <Button
                                        type="button"
                                        label="Borrar"
                                        icon="pi pi-trash"
                                        severity="danger"
                                        outlined
                                        className="p-button-sm"
                                        onClick={() => onDeleteSeller(agent)}
                                        loading={deletingSellerId === agent._id}
                                        disabled={Boolean(deletingSellerId)}
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SalesAgentsView;
